import gql from 'graphql-tag';

export default gql`
    query GetDriversInStandby($jobId: Int, $lofaId: Int) {
        getDriversInStandby(jobId: $jobId, lofaId: $lofaId) {
            driverId
            driverName
            carrierName
            driverPoolNotes
            loadRequested
            loadRejected
            loadDelivered
            onShift
            assignedTime
            distanceToLofa
            checkInWithBellyDump
            isAvailable
        }
    }
`;
